export const SocialLinksComponent = props => null;